import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { EditGroupRequest } from './editgrouprequest';

export class EditGroupAPI extends SixdeeCRBTAPI<EditGroupRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/add-group-members
        return "add-group-members";
    }

    getRequestData()
    {
       return "msisdn="+ this.getRequest().getEditGroupRequest().getMsisdn()+"&"+
              "groupName="+ this.getRequest().getEditGroupRequest().getGroupName()+"&"+
              "groupId="+ this.getRequest().getEditGroupRequest().getGroupId()+"&"+
              "groupDesc="+ this.getRequest().getEditGroupRequest().getGroupDesc()+"&"+
              "memberDetails="+ JSON.stringify(this.getRequest().getEditGroupRequest().getMemberDetails())+"&"+
              "deleteMember="+ this.getRequest().getEditGroupRequest().getDeleteMember()+"&"+
              "toneDetails=[\""+ this.getRequest().getEditGroupRequest().getToneDetails() +"\"]&"+
              "priority="+ this.getRequest().getEditGroupRequest().getPriority()+"&"+
              "language="+ this.getRequest().getEditGroupRequest().getLanguage();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/editgrop/editgroupapi.tsx